import type { InquiryOfType } from "../Inquiry.js";
import type { InquiryType } from "../InquiryType.js";
import { InquiryWeddingStatus } from "../InquiryWeddingStatus.js";

export function canBuyFillings(
	weddingInquiry: InquiryOfType<InquiryType.Wedding> | undefined,
): weddingInquiry is InquiryOfType<InquiryType.Wedding> {
	return (
		weddingInquiry?.weddingDetail.fillingTasteTest === true &&
		weddingInquiry.weddingDetail.status === InquiryWeddingStatus.Approved &&
		weddingInquiry.orderId === undefined
	);
}
